// src/App.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import ScrollToTop from "./ScrollToTop";
import Navbar from "./components/Navbar";

// Pages
import Homepage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import AboutPage from "./pages/AboutPage";
import ServicePage from "./pages/ServicePage";
import ContactPage from "./pages/ContactPage";
import StudioPage from "./pages/StudioPage";
import CareerPage from "./pages/CareerPage";
import BlogPage from "./pages/BlogPage";
import ResearchPage from "./pages/ResearchPage.jsx"
import MaterialMixerApp from "./pages/Ai.jsx";
import Soon from "./pages/Soon.jsx";

// Admin pages
import AdminLogin from "./pages/AdminLogin.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";

// Individual research pages
import ResetStudio from "./research/ResetStudio.jsx";
import CollectiveAssemblies from "./research/CollectiveAssemblies.jsx";
import PalisadesPicnic from "./research/PalisadesPicnic.jsx";
import Thesis from "./research/Thesis.jsx";

// Individual Blog pages
import ConcreteCracking from "./blogs/ConcreteCracking.jsx";
import BlogDetail from "./pages/BlogDetail.jsx";

// Individual project pages
import MoiraGoa from "./projects/MoiraGoa.jsx";
import StudioSharanOffice from "./projects/StudioSharanOffice.jsx";
import SiolimGoa from "./projects/SiolimGoa.jsx";
import Safdarjung from "./projects/Safdarjung.jsx"
import Basement429 from "./projects/Basement429.jsx"

// Animation variants
const pageVariants = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -40 }
};

const navbarVariants = {
  initial: { y: 0, opacity: 1 },
  exit: { y: -80, opacity: 0 },
  enter: { y: 0, opacity: 1 }
};

function App() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />

      {/* Page Animation */}
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.5 }}
        >
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Homepage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/studio" element={<StudioPage />} />
            <Route path="/career" element={<CareerPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/elements" element={<Soon />} />
            <Route path="/research" element={<ResearchPage />} />
            <Route path="/ai" element={<MaterialMixerApp />} />

            {/* Individual Research Routes */}
            <Route path="/research/reset-studio" element={<ResetStudio />} />
            <Route path="/research/collective-assemblies" element={<CollectiveAssemblies />} />
            <Route path="/research/palisades-picnic" element={<PalisadesPicnic />} />
            <Route path="/research/thesis-temp" element={<Thesis />} />

            {/* Individual Research Routes */}
            <Route path="/blogs/concrete-cracking" element={<ConcreteCracking />} />

            {/* Dynamic Blog Route */}
            <Route path="/blogs/:id" element={<BlogDetail />} />

            {/* Individual Project Routes */}
            <Route path="/projects/moira-goa" element={<MoiraGoa />} />
            <Route path="/projects/siolim-goa" element={<SiolimGoa />} />
            <Route path="/projects/studio-sharan" element={<StudioSharanOffice />} />
            <Route path="/projects/safdarjung-delhi" element={<Safdarjung />} />
            <Route path="/projects/basement429-delhi" element={<Basement429 />} />
            <Route path="/projects/soon-project" element={<Soon />} />

            {/* Hidden Admin Routes */}
            <Route path="/x3k9-admin-login" element={<AdminLogin />} />
            <Route path="/x3k9-admin-dashboard" element={<AdminDashboard />} />

          </Routes>
        </motion.div>
      </AnimatePresence>
    </>
  );
}

export default App;
